// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.96.1/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.96.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styles-module__container__ltYaL .styles-module__hithere__vVwNp{background-color:blue}", "",{"version":3,"sources":["webpack://./src/styles.module.scss"],"names":[],"mappings":"AACC,gEACC,qBAAA","sourcesContent":[".container {\n\t.hithere {\n\t\tbackground-color: blue;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "styles-module__container__ltYaL",
	"hithere": "styles-module__hithere__vVwNp"
};
export default ___CSS_LOADER_EXPORT___;
